import { BaleInboundPage } from '@/pages/facility/workflows/bale-inbound';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/facility/bale-inbound')({
	component: BaleInboundPage,
});
